import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { StructureOrganizativeType, CacheService } from 'mapfre-auditlib';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StructureOrganizativeTypeService {

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  className = 'StructureOrganizativeTypeService';

  getAllEOTypes(cache = true, cacheKey = "allEOTypes"): Observable<StructureOrganizativeType[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<StructureOrganizativeType[]>(environment.base_URL + "/types-organizational-structures").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
}
